import React from 'react';

const FILTER_HINT = 'Πατήστε για να ορίσετε τις επιλογές σας';

function FilterSidebar({
    sidebarOpen,
    setSidebarOpen,
    filterSummary = '',
    bodyId,
    className = '',
    children,
}) {
    const toggleSidebar = () => setSidebarOpen((open) => !open);
    const toggleLabel = sidebarOpen ? 'Απόκρυψη φίλτρων' : 'Εμφάνιση φίλτρων';

    return (
        <aside
            className={`ranking-per-state-sidebar ${!sidebarOpen ? 'ranking-per-state-sidebar--collapsed' : ''} ${className}`.trim()}
        >
            <div className="ranking-per-state-sidebar-header">
                <button
                    type="button"
                    className="ranking-per-state-sidebar-vertical-label"
                    onClick={toggleSidebar}
                    aria-expanded={sidebarOpen}
                    aria-controls={bodyId}
                    aria-label={toggleLabel}
                    title={toggleLabel}
                >
                    <span className="predict-sidebar-header-title">Φίλτρα</span>
                    {!sidebarOpen && (
                        filterSummary ? (
                            <span className="predict-sidebar-filter-summary d-md-none">{filterSummary}</span>
                        ) : (
                            <span className="predict-sidebar-filter-hint d-md-none">{FILTER_HINT}</span>
                        )
                    )}
                </button>
                <button
                    type="button"
                    className="ranking-per-state-sidebar-toggle"
                    onClick={toggleSidebar}
                    aria-expanded={sidebarOpen}
                    aria-controls={bodyId}
                    aria-label={toggleLabel}
                    title={toggleLabel}
                >
                    <i className={`bi bi-chevron-${sidebarOpen ? 'left' : 'right'}`} aria-hidden />
                </button>
            </div>
            <div
                id={bodyId}
                className="ranking-per-state-sidebar-body"
                aria-hidden={!sidebarOpen}
            >
                <h6 className="ranking-per-state-sidebar-title">Φίλτρα</h6>
                {children}
            </div>
        </aside>
    );
}

export default FilterSidebar;
